import { render, staticRenderFns } from "./updateInfoResult.vue?vue&type=template&id=23cba9f0&"
import script from "./updateInfoResult.vue?vue&type=script&lang=js&"
export * from "./updateInfoResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports